import React from 'react';

import { useFormContext } from 'react-hook-form';

import { IconButton } from '@mui/material';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import { SelectProps } from '@mui/material/Select/Select';

import {
  MultipleSelectCheckmarks,
  MultiSelectOption
} from '../MultipleSelectCheckmarks';
import { Icon } from '@sdb/planning-ui';

interface Props {
  label: string;
  name: string;
  options: MultiSelectOption[];
  variant?: SelectProps['variant'];
  showList?: boolean;
  fullWidth?: boolean;
  disabled?: boolean;
  error?: any;
}

const ControlledMultiSelect: React.FC<Props> = ({
  label,
  options,
  error,
  name,
  fullWidth = false,
  variant = 'standard',
  showList = false,
  disabled = false
}) => {
  const { setValue, watch } = useFormContext();

  const onRemoveElement = (selectedOption) => {
    setValue(
      name,
      watch(name).filter((option) => option !== selectedOption),
      { shouldDirty: true }
    );
  };

  return (
    <>
      <MultipleSelectCheckmarks
        options={options}
        variant={variant}
        label={label}
        selectedOptions={watch(name) ?? []}
        onChange={(options) => {
          setValue(name, options, { shouldDirty: true });
        }}
        formControlProps={{ disabled, error }}
        fullWidth={fullWidth}
      />
      {showList && (
        <List dense>
          {watch(name)?.map((selectedOption) => (
            <ListItem
              key={selectedOption}
              secondaryAction={
                !disabled ? (
                  <IconButton
                    onClick={() => onRemoveElement(selectedOption)}
                    size="large"
                  >
                    <Icon type="xmark" fontSize="small" sx={{ fontSize: 13 }} />
                  </IconButton>
                ) : null
              }
            >
              <ListItemText
                primary={
                  options.find((option) => option.value === selectedOption)
                    ?.label
                }
              />
            </ListItem>
          ))}
        </List>
      )}
    </>
  );
};

export default ControlledMultiSelect;
